import React, { useCallback, useEffect, useState } from "react";
import { Button, CircularProgress, TextField } from "@mui/material";
import api from "../../services/api";
import toastError from "../../errors/toastError";

export default function MetaAdsPanel({ isAdmin, dateFrom, dateTo, onChanged }) {
  const [accounts, setAccounts] = useState([]);
  const [accountId, setAccountId] = useState("");
  const [token, setToken] = useState("");
  const [busy, setBusy] = useState(false);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/dashboard/v2/meta-accounts");
      setAccounts(Array.isArray(data) ? data : []);
    } catch (error) {
      toastError(error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { if (isAdmin) load(); }, [isAdmin, load]);
  if (!isAdmin) return <p>Somente administradores podem consultar e conectar contas de anúncios.</p>;

  const connect = async event => {
    event.preventDefault();
    setBusy(true);
    try {
      await api.post("/dashboard/v2/meta-accounts", { adAccountId: accountId, accessToken: token });
      setAccountId("");
      setToken("");
      await load();
      onChanged?.();
    } catch (error) {
      toastError(error);
    } finally {
      setBusy(false);
    }
  };

  const sync = async id => {
    setBusy(true);
    try {
      await api.post(`/dashboard/v2/meta-accounts/${id}/sync`, { dateFrom, dateTo });
      await load();
      onChanged?.();
    } catch (error) {
      toastError(error);
    } finally {
      setBusy(false);
    }
  };

  return (
    <section style={{ background: "#fff", border: "1px solid #dfe4e1", borderRadius: 16, padding: 16 }}>
      <h2 style={{ margin: "0 0 12px", fontSize: 16 }}>Contas de anúncios</h2>
      {loading ? <CircularProgress size={22} /> : accounts.length ? accounts.map(account => (
        <div key={account.id} style={{ display: "flex", gap: 10, alignItems: "center", justifyContent: "space-between", borderTop: "1px solid #e8ecea", padding: "9px 0", flexWrap: "wrap" }}>
          <div><strong>{account.name}</strong><small style={{ display: "block", color: "#7e8882" }}>
            act_{account.adAccountId} · {account.lastSyncedAt ? `sincronizado ${new Date(account.lastSyncedAt).toLocaleString("pt-BR")}` : "sem sincronização"}
          </small>{account.lastError && <small style={{ color: "#bb2c22" }}>{account.lastError}</small>}</div>
          <Button size="small" variant="outlined" disabled={busy || (new Date(dateTo) - new Date(dateFrom)) > 90 * 86400000} onClick={() => sync(account.id)}>Sincronizar período</Button>
        </div>
      )) : <p>Nenhuma conta conectada.</p>}
      <form onSubmit={connect} style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 12 }}>
        <TextField size="small" label="ID da conta de anúncios" value={accountId} onChange={event => setAccountId(event.target.value)} required />
        <TextField size="small" type="password" label="Token com ads_read" value={token} onChange={event => setToken(event.target.value)} required style={{ flex: "1 1 220px" }} />
        <Button type="submit" variant="contained" disabled={busy}>Conectar</Button>
      </form>
      <small style={{ color: "#7e8882" }}>A sincronização usa o período selecionado (até 90 dias). O token fica criptografado no servidor.</small>
    </section>
  );
}
